/* global Marionette, define, nfRadio */
/* eslint-disable no-var, object-shorthand */
/**
 * Registers the conversational view as the form's content view.
 */
define( 'controllers/formContent',[ 'views/conversational' ], function ( ConversationalView ) {
	var controller = Marionette.Object.extend( {
		/**
		 * Claim the form content view at priority 0.
		 *
		 * Priority 0 runs ahead of every other content view filter, so the
		 * conversational view is the outermost one and can wrap whichever
		 * view those later filters would have produced.
		 *
		 * @return {void}
		 */
		initialize: function () {
			nfRadio
				.channel( 'formContent' )
				.request( 'add:viewFilter', this.getView, 0 );
		},

		/**
		 * Supply the conversational view constructor to Ninja Forms.
		 *
		 * @return {Function} The conversational view.
		 */
		getView: function () {
			return ConversationalView;
		},
	} );

	return controller;
} );

